module.exports = __webpack_public_path__ + "img/doubt.7b9272aa.gif";